<template>
  <section class="post-detail">
    <h2>{{ title }}</h2>

    <div class="top-btn">
      <v-button
        v-if="isScheduled"
        @click="onSchedule">Save Changes</v-button>
      <v-button
        v-if="isDraft"
        @click="onSaveDraft">Save Draft</v-button>
      <v-button
        v-if="isPublished"
        @click="onPublish">Publish Changes</v-button>
    </div>

    <el-tabs
      v-model="activeTab"
      type="card"
      class="post-tab">
      <el-tab-pane
        v-for="(tab, index) in tabList"
        :key="index"
        :label="tab.label"
        :name="String(tab.name)"
      ></el-tab-pane>
    </el-tabs>

    <section
      v-show="activeTab == 'content'"
      class="form-container">
      <el-form
        ref="form"
        :model="formData"
        :rules="rules">
        <div class="flex-sb">
          <div class="form-item form-half">
            <span>Title (English)</span>
            <el-form-item
              ref="data.en.title"
              :rules="rules.input"
              prop="data.en.title">
              <v-input v-model="formData.data.en.title" />
            </el-form-item>
          </div>
          <div class="form-item form-half">
            <span>Title (Traditional Chinese)</span>
            <el-form-item
              ref="data.hk.title"
              :rules="rules.input"
              prop="data.hk.title">
              <v-input v-model="formData.data.hk.title" />
            </el-form-item>
          </div>
        </div>
        <div class="flex-sb">
          <div class="form-item form-half">
            <span>Author (English)</span>
            <el-form-item
              ref="data.en.author"
              :rules="rules.input"
              prop="data.en.author">
              <v-input v-model="formData.data.en.author" />
            </el-form-item>
          </div>
          <div class="form-item form-half">
            <span>Author (Traditional Chinese)</span>
            <el-form-item
              ref="data.hk.author"
              :rules="rules.input"
              prop="data.hk.author">
              <v-input v-model="formData.data.hk.author" />
            </el-form-item>
          </div>
        </div>
        <div class="flex-sb">
          <div class="form-item form-half">
            <span>Description (English)</span>
            <el-form-item
              ref="data.en.description"
              :rules="rules.input"
              prop="data.en.description">
              <v-input v-model="formData.data.en.description" />
            </el-form-item>
          </div>
          <div class="form-item form-half">
            <span>Description (Traditional Chinese)</span>
            <el-form-item
              ref="data.hk.description"
              :rules="rules.input"
              prop="data.hk.description">
              <v-input v-model="formData.data.hk.description" />
            </el-form-item>
          </div>
        </div>

        <div class="flex-sb">
          <div class="form-half">
            <div class="flex-upload">
              <div class="form-item">
                <span>Cover (English)</span>
                <el-form-item
                  ref="data.en.cover_image_url"
                  :rules="rules.upload"
                  prop="data.en.cover_image_url">
                  <v-upload
                    class="upload-cover"
                    :card="true"
                    :isBlog="true"
                    :notUpload="true"
                    :otherData="{
                      lang: 'en',
                      target: 'cover'
                    }"
                    :fileData="{
                      thumb_url: formData.data.en.cover_image_url,
                      url: formData.data.en.cover_image_url
                    }"
                    @uploadForm="handlerUploadSuccess"
                    @delete="handlerUploadDelete" />
                </el-form-item>
              </div>
              <div class="form-item">
                <span>Hero (English)</span>
                <el-form-item
                  ref="data.en.hero_image_url"
                  :rules="rules.upload"
                  prop="data.en.hero_image_url">
                  <v-upload
                    class="upload-hero"
                    :card="true"
                    :isBlog="true"
                    :notUpload="true"
                    :otherData="{
                      lang: 'en',
                      target: 'hero'
                    }"
                    :fileData="{
                      thumb_url: formData.data.en.hero_image_url,
                      url: formData.data.en.hero_image_url
                    }"
                    @uploadForm="handlerUploadSuccess"
                    @delete="handlerUploadDelete" />
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="form-half">
            <div class="flex-upload">
              <div class="form-item">
                <span>Cover (Traditional Chinese)</span>
                <el-form-item
                  ref="data.hk.cover_image_url"
                  :rules="rules.upload"
                  prop="data.hk.cover_image_url">
                  <v-upload
                    class="upload-cover"
                    :card="true"
                    :isBlog="true"
                    :notUpload="true"
                    :otherData="{
                      lang: 'hk',
                      target: 'cover'
                    }"
                    :fileData="{
                      thumb_url: formData.data.hk.cover_image_url,
                      url: formData.data.hk.cover_image_url
                    }"
                    @uploadForm="handlerUploadSuccess"
                    @delete="handlerUploadDelete" />
                </el-form-item>
              </div>
              <div class="form-item">
                <span>Hero (Traditional Chinese)</span>
                <el-form-item
                  ref="data.hk.hero_image_url"
                  :rules="rules.upload"
                  prop="data.hk.hero_image_url">
                  <v-upload
                    class="upload-hero"
                    :card="true"
                    :isBlog="true"
                    :notUpload="true"
                    :otherData="{
                      lang: 'hk',
                      target: 'hero'
                    }"
                    :fileData="{
                      thumb_url: formData.data.hk.hero_image_url,
                      url: formData.data.hk.hero_image_url
                    }"
                    @uploadForm="handlerUploadSuccess"
                    @delete="handlerUploadDelete" />
                </el-form-item>
              </div>
            </div>
          </div>
        </div>

        <div class="flex-sb">
          <div class="form-item form-half">
            <span>Post Body (English)</span>
            <el-form-item
              ref="data.en.content"
              :rules="rules.input"
              prop="data.en.content">
              <div>
                <v-editor
                  ref="en-editor"
                  :otherData="{
                    'target': 'en'
                  }"
                  @save="handlerSaveEditor" />
              </div>
            </el-form-item>
          </div>
          <div class="form-item form-half">
            <span>Post Body (Traditional Chinese)</span>
            <el-form-item
              ref="data.hk.content"
              :rules="rules.input"
              prop="data.hk.content">
              <div>
                <v-editor
                  id="editorjsHK"
                  ref="hk-editor"
                  :otherData="{
                    'target': 'hk'
                  }"
                  @save="handlerSaveEditor" />
              </div>
            </el-form-item>
          </div>
        </div>
        <div class="flex-sb">
          <div class="form-item form-half">
            <span>Tags (English)</span>
            <el-form-item
              ref="data.en.tags"
              prop="data.en.tags">
              <el-form-item
                ref="data.hk.tags"
                prop="data.hk.tags">
                <v-input-tags v-model="formData.data.en.tags"></v-input-tags>
              </el-form-item>

            </el-form-item>
          </div>
          <div class="form-item form-half">
            <span>Tags (Chinese)</span>
            <el-form-item
              ref="data.hk.tags"
              prop="data.hk.tags">
              <v-input-tags v-model="formData.data.hk.tags"></v-input-tags>
            </el-form-item>
          </div>
        </div>
      </el-form>

      <div class="post-footer">
        <div class="left">
          <v-button
            plain
            @click="onDiscard">{{ isEdit? 'Discard Changes': 'Discard' }}</v-button>
          <v-button
            v-if="isEdit"
            type="danger"
            plain
            @click="onDelete">Delete</v-button>
        </div>
        <div class="right">
          <v-button @click="onPreview">Preview</v-button>
          <v-button
            type="success"
            @click="onNext">Next</v-button>
        </div>
      </div>

    </section>
    <section
      v-show="activeTab == 'setting'"
      class="form-container">
      <el-form
        ref="setting-form"
        :model="formData"
        :rules="rules">
        <div class="form-half">
          <div class="form-item">
            <span>Category</span>
            <el-form-item
              ref="category_id"
              :rules="rules.select"
              prop="category_id">
              <v-select
                v-model="formData.category_id"
                class="category-box"
                placeholder="Select Category"
                :list="categoriesList" />
            </el-form-item>
          </div>
          <!--          <div class="form-item">-->
          <!--            <span>Tags</span>-->
          <!--            <el-form-item-->
          <!--              ref="tag_ids"-->
          <!--              :rules="rules.select_multiple"-->
          <!--              prop="tag_ids">-->
          <!--              <v-select-->
          <!--                v-model="formData.tag_ids"-->
          <!--                multiple-->
          <!--                class="category-box"-->
          <!--                placeholder="Select Tag"-->
          <!--                :list="tagsList" />-->
          <!--            </el-form-item>-->
          <!--          </div>-->
          <div class="form-item">
            <span>Slug</span>
            <el-form-item
              ref="post_url_slug"
              prop="post_url_slug">
              <v-input v-model="formData.post_url_slug" />
            </el-form-item>
          </div>
          <div class="form-item">
            <span>URL Preview</span>
            <div class="url-preview">
              <div class="block">{{`${agencyURL}blog/`}}<span>{{ formData.post_url_slug }}</span></div>
              <div>{{`${agencyURL}en/blog/`}}<span>{{ formData.post_url_slug }}</span></div>
            </div>
          </div>
          <div class="form-item">
            <span>Display</span>
            <v-checkbox v-model="formData.privacy" >Do not list post in news & category page</v-checkbox>
          </div>
          <div class="form-item">
            <v-checkbox v-model="formData.ali_not_show">Do not list for AlipayHK</v-checkbox>
          </div>
          <div class="form-item">
            <v-checkbox v-model="formData.feature_popular">Set as popular post</v-checkbox>
          </div>

          <h4>Publish Date</h4>
          <div class="form-item">
            <v-radio-group
              v-if="isPublished"
              v-model="scheduleBackFuture"
              :list="scheduleDateList" />
            <v-checkbox
              v-else
              v-model="publish">Schedule Publish</v-checkbox>

            <el-form-item
              v-if="isPublished"
              ref="publish_date"
              class="pd-t-8"
              :rules="rules.publish_date"
              prop="publish_date">
              <v-datetime-picker
                v-model="formData.publish_date"
                :pickerOptions="isPublished? pickerOptions: null"
                :disabled="!publish && !isPublished" />
            </el-form-item>

            <el-form-item
              v-else
              ref="schedule_date"
              class="pd-t-8"
              :rules="rules.schedule_date"
              prop="schedule_date">
              <v-datetime-picker
                v-model="formData.schedule_date"
                :pickerOptions="isPublished? pickerOptions: null"
                :disabled="!publish && !isPublished" />
            </el-form-item>
          </div>
          <div class="form-item">
            <v-checkbox v-model="unpublish">Schedule Unpublish</v-checkbox>
            <el-form-item
              ref="unpublish_date"
              class="pd-t-8"
              :rules="rules.unpublish_date"
              prop="unpublish_date">
              <v-datetime-picker
                v-model="formData.unpublish_date"
                :disabled="!unpublish"/>
            </el-form-item>
          </div>
        </div>
      </el-form>
      <div class="post-footer">
        <div class="left">
          <v-button @click="onBack">Back</v-button>
        </div>
        <div class="right">
          <v-button
            v-if="!isDraft"
            @click="onSaveDraft">{{ (isScheduled || isPublished)? 'Downgrade to Draft': 'Save Draft' }}</v-button>

          <template v-if="isPublished">
            <v-button
              @click="onPublish">{{ scheduleBackFuture == 'back'? 'Publish Changes': 'Reschedule' }}</v-button>
            <!-- <v-button
              v-if="scheduleBackFuture == 'back'"
              @click="onPublish">Publish Changes</v-button>
            <v-button
              v-else
              @click="onSchedule">Reschedule</v-button> -->
          </template>
          <template v-else>
            <v-button
              v-if="publish == 0"
              :type="!isEdit? 'success': ''"
              @click="onPublish">Publish Now</v-button>
            <v-button
              v-else
              :type="(!isEdit || isScheduled)? 'success': ''"
              @click="onSchedule">{{ isPublished? 'Reschedule': 'Schedule Post' }}</v-button>
          </template>

          <v-button
            v-if="isDraft"
            @click="onSaveDraft">{{ (isScheduled || isPublished)? 'Downgrade to Draft': 'Save Draft' }}</v-button>

        </div>
      </div>
    </section>
    <post-preview-popup
      v-model="showPostPreviewPopup"
      :content="previewContent" />
  </section>
</template>
<script>
import {mapActions} from 'vuex'
import PostPreviewPopup from './components/popup/post-preview'
import MixinRules from '@/mixins/rules'
import {
  addNewsArticle,
  deleteArticle,
  getArticleDetail,
  getNewsCategoriesList,
  getNewsTags,
  updateArticleDetail,
  uploadNewsImage
} from '@/api/news'

export default {
  name: 'newPostDetail',
  components: {
    PostPreviewPopup
  },
  mixins: [MixinRules],
  data() {
    const checkScheduleDate = (rule, value, callback) => {
      if(this.publish == 1 && !value) {
        callback(new Error(this.$t('placeholder.select')))
      }
      callback()
    }
    const checkUnpublishDate = (rule, value, callback) => {
      if(this.unpublish && !value) {
        callback(new Error(this.$t('placeholder.select')))
      }
      callback()
    }
    const checkPublishDate = (rule, value, callback) => {
      if(this.status==1 && !this.formData.publish_date) {
        callback(new Error(this.$t('placeholder.select')))
      }
      callback()
    }
    return {
      showPostPreviewPopup: false,
      previewContent: null,
      activeTab: 'content',
      enTags:'',
      hkTags:'',
      tabList: [
        {
          name: 'content',
          label: 'Content'
        },
        {
          name: 'setting',
          label: 'Post Settings'
        }
      ],
      scheduleBackFuture: 'back',
      scheduleDateList: [
        {
          id: 'back',
          name: 'Back Date'
        },
        {
          id: 'future',
          name: 'Reschedule to future'
        }
      ],
      formData: {
        status: -1,
        feature: false,
        privacy: false,
        schedule_date: '',
        unpublish_date: '',
        publish_date: '',
        category_id: '',
        post_url_slug: '',
        // tag_ids: [],
        data: {
          en: {
            title: '',
            description: '',
            author: '',
            content: '',
            cover_image_file_id: '',
            cover_image_url: '',
            hero_image_file_id: '',
            hero_image_url: '',
            tags:[],
          },
          hk: {
            title: '',
            description: '',
            author: '',
            content: '',
            cover_image_file_id: '',
            cover_image_url: '',
            hero_image_file_id: '',
            hero_image_url: '',
            tags:[],
          }
        },
        recommended_reading_time: 300, // 接口必填
        feature_popular: 0,
        ali_not_show: 0,
      },
      publish: 0,
      unpublish: false,
      categoriesList: [],
      tagsList: [],
      extraRules: {
        schedule_date: [
          { validator: checkScheduleDate, trigger: ['change', 'blur'] }
        ],
        unpublish_date: [
          { validator: checkUnpublishDate, trigger: ['change', 'blur'] }
        ],
        publish_date: [
          { validator: checkPublishDate, trigger: ['change', 'blur'] }
        ],
      },
      //   pickerOptions: {
      //     disabledDate(time){

    //       return time.getTime()<Date.now()
    //     }
    //   },
    }
  },
  computed: {
    title() {
      if(this.isEdit) {
        if(this.isDraft) {
          return 'Edit Draft'
        }
        else if(this.isPublished) {
          return 'Edit Published Post'
        }
        else if(this.isScheduled) {
          return 'Edit Scheduled Post'
        }
        return 'Edit Post'
      }
      return 'New Post'
    },
    articleId() {
      return this.$route.query.id
    },
    isEdit() {
      return this.articleId? true: false
    },
    status() {
      // 0-Draft, 1-Published, 2-Scheduled, 3-Unpublished
      return Number(this.formData.status)
    },
    isDraft() {
      return this.status === 0
    },
    isPublished() {
      return this.status === 1
    },
    isScheduled() {
      return this.status === 2
    },
    isUnpublished() {
      return this.status === 3
    },
    pickerOptions() {
      if(!this.isPublished) return null
      return {
        disabledDate: (time) => {
          if(this.scheduleBackFuture == 'back') {
            return time.getTime() > Date.now()
          }
          else {
            return time.getTime() < Date.now()
          }
        }
      }
    },
    domain(){
      let domain = localStorage.getItem('agency_id')||0
      return Number(domain)
    },
    agencyURL(){
      let obj = {
        2 : 'https://www.eains.biz/',
        3 : 'https://www.insurance168.com/',
        6 : 'https://www.algofin.co/',
        9 : 'https://roadbomb.trustful.hk/'
      }
      return obj[this.domain]
    }
  },
  watch: {
    property: {
      immediate: true,
      handler() {
        this.network().getNewsCategoriesList()
        this.network().getNewsTagsList()
        if(this.articleId) {
          this.network().getArticleDetail()
        }
      }
    },
    // isPublished: {
    //   immediate: true,
    //   handler(val) {
    //     if(val) {
    //       this.publish == 1
    //     }
    //   }
    // },
    publish: {
      handler(val) {
        try {
          this.$refs['setting-form'].clearValidate(['schedule_date'])
        } catch (e) {
          console.log(e)
        }
      }
    },
    unpublish: {
      handler(val) {
        try {
          this.$refs['setting-form'].clearValidate(['unpublish_date'])
        } catch (e) {
          console.log(e)
        }
      }
    },
    'formData.data.hk.content': {
      deep: true,
      handler(val) {
        if(val !== '') {
          this.$refs['form'].clearValidate(['data.hk.content'])
        }
      }
    },
    'formData.data.en.content': {
      deep: true,
      handler(val) {
        if(val !== '') {
          this.$refs['form'].clearValidate(['data.en.content'])
        }
      }
    },
  },
  methods: {
    ...mapActions('news', ['setPostPreview']),
    handleTag(type){
      this.formData.data.en.tags.push(this.enTags)
    },
    handleClose(tag,type) {
      this.formData.data[type].tags.splice(this.tags.indexOf(tag), 1)
    },
    handleCNTag(){
      this.formData.data.hk.tags.push(this.hkTags)
    },
    onBack() {
      this.activeTab = 'content'
      this.scrollTo(0)
    },
    onDiscard() {
      this.$ConfirmBox({
        title: 'Discard Changes',
        message: 'Are you sure to discard all changes to this post?'
      })
        .then(() => {
          this.$router.push({
            path: '/admin-cms/blog'
          })
        })
    },
    onDelete() {
      this.$ConfirmBox({
        title: 'Delete Post',
        message: 'Are you sure you want to delete this post?'
      })
        .then(() => {
          this.network().deleteArticle()
        })
    },
    onPublish() {
      this.handlerSave({
        publish: 'yes'
      })
    },
    onSchedule() {
      this.handlerSave()
    },
    onSaveDraft() {
      this.handlerSave({
        draft: 'yes'
      })
    },
    handlerSave(params = {}) {
      this.$refs['setting-form'].validate((valid, rules) => {
        if(valid) {
          // 校驗 Content
          this.onNext(true, params)
        }
        else {
          this.scrollToValidDom(rules)
        }
      })
    },
    async onPreview() {
      await this.$refs['en-editor'].handlerSave()
      await this.$refs['hk-editor'].handlerSave()
      console.log(this.formData.data)
      // popup 版本
      // const { content } = this.formData.data.en
      // this.previewContent = JSON.parse(content)
      // this.showPostPreviewPopup = true

      // new tab 版本
      const { en, hk } = this.formData.data
      const previewData = {
        en: JSON.parse(en.content),
        hk: JSON.parse(hk.content)
      }
      this.setPostPreview(previewData)
      const { href } = this.$router.resolve({
        // path: '/post/preview'
        name: 'PostPreview'
      })
      window.open(href, '_blank')

    },
    async onNext(fromSetting = false, params) {
      await this.$refs['en-editor'].handlerSave()
      await this.$refs['hk-editor'].handlerSave()

      this.$refs['form'].validate((valid, rules) => {
        if(valid) {
          if(fromSetting) {
            // 提交數據
            const data = this.handler().handlerFormData(params)
            const lastParams = {
              ...data,
              ...params
            }
            if(this.articleId) {
              this.network().updateArticleDetail(lastParams)
            }
            else {
              this.network().addNewsArticle(lastParams)
            }
            return
          }
          this.activeTab = 'setting'
          this.scrollTo(0)
        }
        else {
          if(fromSetting) {
            this.activeTab = 'content'
          }
          this.scrollToValidDom(rules)
        }
      })
    },
    handlerSaveEditor({ data, otherData }) {
      const { target } = otherData
      // const dataStr = JSON.stringify(data)
      if(target == 'en') {
        this.$set(this.formData.data.en, 'content', data)
      }
      else {
        this.$set(this.formData.data.hk, 'content', data)
      }
    },
    handlerUploadSuccess({ params, result, otherData }) {
      // 這裏還要上傳
      this.network().uploadNewsImage({ params, result, otherData })
    },
    handlerUploadDelete({ otherData }) {
      const { lang, target } = otherData

      this.$set(this.formData.data[lang], `${target}_image_file_id`, '')
      this.$set(this.formData.data[lang], `${target}_image_url`, '')

      this.$refs['form'].clearValidate([`data.${lang}.${target}_image_url`])
    },
    handler() {
      return {
        handlerFormData: (other = {}) => {
          let params = JSON.parse(JSON.stringify(this.formData))

          if(this.isPublished) {
            this.publish = 1
          }

          if(!this.unpublish) {
            delete params.unpublish_date
          }
          if(this.publish === 0) {
            delete params.schedule_date
          }

          const { publish, draft } = other

          if(draft == 'yes' || publish == 'yes') {
            delete params.schedule_date
          }

          params.privacy = params.privacy? 1: 0
          params.feature = params.feature? 1: 0

          if(params.schedule_date) {
            params.schedule_date = `${params.schedule_date}:00`
          }
          if(params.unpublish_date) {
            params.unpublish_date = `${params.unpublish_date}:00`
          }

          return params
        }
      }
    },
    network() {
      return {
        getArticleDetail: async () => {
          let { data } = await getArticleDetail({
            article_id: this.articleId
          })
          data.privacy = data.privacy === 1? true: false
          data.feature = data.feature === 1? true: false
          data.data = data.data.reduce((result, item) => {
            if(item.language == 'en-US') {
              result['en'] = item
            } else {
              result['hk'] = item
            }
            return result
          }, {})
          const { status, unpublish_date } = data
          switch (Number(status)) {
            case 1:
              this.publish = 0
              break
            case 2:
              this.publish = 1
              break
            case 3:
              this.unpublish = true
              break
          }

          if(unpublish_date) {
            this.unpublish = true
          }

          this.formData = Object.assign(this.formData, data)

          // 初始化富文本編輯器內容
          setTimeout(() => {
            this.$refs['en-editor'].initData(this.formData.data.en.content)
            this.$refs['hk-editor'].initData(this.formData.data.hk.content)
          }, 400)
        },
        getNewsCategoriesList: async () => {
          const { data } = await getNewsCategoriesList({
            hideLoading: true
          })
          const list = data.reduce((result, item) => {
            result.push({
              id: item.category_id,
              name: item.name
            })
            return result
          }, [])
          this.categoriesList = list
        },
        getNewsTagsList: async () => {
          let { data } = await getNewsTags({
            hideLoading: true
          })

          const list = data.reduce((result, item) => {
            const { name_language } = item
            result.push({
              id: item.id,
              name: `${name_language['en-US']} ${name_language['zh-HK']}`
            })
            return result
          }, [])
          this.tagsList = list
        },
        uploadNewsImage: async ({ params, result, otherData }) => {
          const { data } = await uploadNewsImage(params)
          const { lang, target } = otherData
          const { url } = result
          this.$set(this.formData.data[lang], `${target}_image_file_id`, data.image_id)
          this.$set(this.formData.data[lang], `${target}_image_url`, url)

          this.$refs['form'].clearValidate([`data.${lang}.${target}_image_url`])


          this.$message({
            type: 'success',
            message: 'Upload Success'
          })
        },
        deleteArticle: async () => {
          const { data } = await deleteArticle({
            article_id: this.articleId
          })
          this.$ConfirmBox({
            title: 'Delete Post',
            message: 'This post has been deleted.',
            cancelBtn: '',
            confirmBtn: 'Done'
          })
            .then(() => {
              this.$router.push({
                path: '/admin-cms/blog'
              })
            })
        },
        addNewsArticle: async params => {
          const { data } = await addNewsArticle(params)
          this.$router.push({
            path: '/admin-cms/blog'
          })
        },
        updateArticleDetail: async params => {
          const { data } = await updateArticleDetail({
            ...params,
            article_id: this.articleId
          })
          this.$router.push({
            path: '/admin-cms/blog'
          })
        },
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.post-detail {
    position: relative;
    margin: -20px;
    padding: 20px;
    min-height: 100vh;
    background: white;
    .top-btn {
        position: absolute;
        top: 20px;
        right: 20px;
    }
    .post-tab {
        margin: 20px 0;
    }
    .upload-cover {
       /deep/ .upload-card {
            width: 300px;
            height: 150px;
        }
    }
    .post-footer {
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
        padding-top: 30px;
        width: 100%;
        border-top: 1px solid #ccc;
    }
    h4 {
        padding-bottom: 20px;
    }
    .form-item {
        .pd-t-8 {
            padding-top: 8px;
        }
    }
    .url-preview {
        font-size: 14px;
        color: gray;
        span {
            color: #012a63;
        }
    }
    .flex-upload {
        display: flex;
        .form-item:first-child {
            margin-right: 20px;
        }
    }
    /deep/.el-checkbox{
      display: flex;
      align-items: center;
    }
}
</style>

<style lang="scss">
.v-upload-container {
    &.upload-cover {
        .upload-container {
            width: 300px;
            height: 150px;
        }
    }
    &.upload-hero {
        .upload-container {
            width: 150px;
            height: 150px;
            .upload-card {
                width: 150px;
                height: 150px;
            }
        }
    }
}
</style>
